import { render, staticRenderFns } from "./RevenueShareFormTable.vue?vue&type=template&id=6fbf4c94&scoped=true&"
import script from "./RevenueShareFormTable.vue?vue&type=script&lang=js&"
export * from "./RevenueShareFormTable.vue?vue&type=script&lang=js&"
import style0 from "./RevenueShareFormTable.vue?vue&type=style&index=0&id=6fbf4c94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbf4c94",
  null
  
)

export default component.exports